const rpArgsPc = (listColecc, dataChange, saldoPendiente, totRecibido, numeroRC, descrRecurso,
                  numeroDocumUA, fechaHoraHoy, userLogin) => {
  // let fechaHoy = new Date()
  // let horaHoy = fechaHoy.getHours()+":"+fechaHoy.getMinutes()+":"+fechaHoy.getSeconds();
  // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

  let fechaHoy = fechaHoraHoy.substr(0, 10)
  let horaHoy = fechaHoraHoy.substr(11, 8)
// console.log(fechaHoraHoy)
// console.log(fechaHoy, horaHoy)

  let argsAdd = dataChange

  let saldoCl = parseInt(saldoPendiente, 10) - parseInt(totRecibido, 10)
  let creaColecc = [], movColecc = []

  argsAdd['saldoPendiente'] = saldoCl
  argsAdd['fechaPago'] = fechaHoy
  // argsAdd['fechaPago'] = fechaFechaHoy
  argsAdd['tipo'] = "PO"
  argsAdd['numeroRC'] = numeroRC
  argsAdd['documento'] = numeroRC
  if(descrRecurso!==""){
    argsAdd['descripcionPago'] = "Pago en tercero"
    // argsAdd['numeroRT'] = argsAdd.numeroRT
    argsAdd['numeroDocum'] = numeroDocumUA
    argsAdd['descrRecurso'] = descrRecurso  
  }else{
    argsAdd['descripcionPago'] = "Pago en oficina"
  }
  argsAdd['valorTotal'] = totRecibido
  argsAdd['fechaCreate'] = fechaHoy + ' ' + horaHoy
  argsAdd['usuarioCreate'] = userLogin
  // argsAdd['fechaCreate'] = fechaHoraHoy
  creaColecc.push(argsAdd)
// console.log(argsAdd)
  listColecc.forEach((elemento1, ii) => {
    if(elemento1.valorRecibido&&elemento1.valorRecibido!==0){
      let argsUpd = {
        "contrato": elemento1.contrato,
        "tipoAct": ii===0?"CreardetallePC1":"CreardetallePC2",
        "idMovClientes": elemento1._id,
        "codigoServicio": elemento1.codigoServicio,
        "nombreResumido": elemento1.nombreResumido,
        "descripcionServicio": elemento1.descripcionServicio,
        "descrClaseServ": elemento1.descrClaseServ,
        "concepto": elemento1.concepto,
        "periodo": elemento1.periodo,
        "valorTotal": elemento1.valorTotal,
        "valorDetalle": elemento1.valorRecibido,
      }
      movColecc.push(argsUpd)
      //console.log("movColecc", argsUpd)
    }
  })

  let colecc = {creaColecc, movColecc}

  return colecc
}

export default rpArgsPc
  